



















































import { Component, Prop, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import GeneralModule from "@/store/modules/General";
import BankAccountModule from "@/store/modules/BankAccount";
import ErrorHandleMixin from "@/mixins/ErrorHandle.vue";
import AuthModule from "@/store/modules/Auth";
import utils from "@/services/utils";

@Component
export default class DateRangeLogBody extends Mixins(ErrorHandleMixin) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  BankAccountInstance = getModule(BankAccountModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  isAdmin = ["SUPERADMIN", "ADMIN"].includes(this.AuthInstance.user.role);

  @Prop() readonly startdate: any;

  @Prop() readonly enddate: any;

  @Prop() readonly data: any;

  @Prop() readonly fetchWinloseByDuration!: Function;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly mainRole!: string;

  @Prop() readonly durationTime!: string;

  utilsInstance = utils;

  checkTransaction = [];

  handleTimeRange(username, role, source, id, durationTime) {
    this.fetchWinloseByDuration(username, role, source, id, durationTime);
  }
}
